/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Form, Input, Button, message } from 'antd'
import { isEmail } from 'validator'
import { FaDiscord } from 'react-icons/fa';

import AppLayout from '../../layouts/AppLayout'
import api from '../../services/api'

function Settings() {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(true)
  const [discordUsername, setDiscordUsername] = useState(null);

  const layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 10 },
  }
  const tailLayout = {
    wrapperCol: { offset: 2, span: 10 },
  }

  async function getData() {
    setLoading(true)
    try {
      const result = await api.get('/user/me')
      form.setFieldsValue({
        username: result.data.username,
        email: result.data.email,
      })
      setDiscordUsername(result.data.discord);
    } catch (err) {
      message.error('Não foi possível buscar suas informações no momento')
    } finally {
      setLoading(false)
    }
  }

  async function submit(values) {
    if (!values.email) return message.info('Informe um e-mail')
    if (!isEmail(values.email)) return message.warning('Informe um e-mail válido')
    if (values.password && values.password.length < 6) {
        return message.warning('A nova senha deve ter pelo menos 6 caracteres');
    }

    const updateData: any = { email: values.email };
    if (values.password) {
      updateData.password = values.password;
    }

    setLoading(true)
    try {
      await api.patch('/user', updateData)
      message.success('Dados atualizados!')
      form.setFieldsValue({ password: '' });
    } catch (err) {
      message.error(err.response?.data?.message || 'Erro ao atualizar dados.')
    } finally {
      setLoading(false)
    }
  }

  const handleLinkDiscord = () => {
    // Read the Client ID from frontend environment variables
    const discordClientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
    const frontendRedirectUri = encodeURIComponent(window.location.origin + '/discord/callback/link'); 
    const scope = encodeURIComponent('identify email');
    
    // Check if the environment variable is actually set
    if (!discordClientId) { 
        message.error('REACT_APP_DISCORD_CLIENT_ID não está configurado no .env do frontend.');
        return;
    }

    const discordAuthUrl = `https://discord.com/api/oauth2/authorize?client_id=${discordClientId}&redirect_uri=${frontendRedirectUri}&response_type=code&scope=${scope}`;
    
    window.location.href = discordAuthUrl;
  };

  useEffect(() => {
    getData()
  }, [])

  return (
    <AppLayout page="settings" title="Configurações da Conta">
      <h5>Configurações da conta</h5>
      <br />
      <Form {...layout} name="settings-form" form={form} onFinish={submit} autoComplete="off">
        <Form.Item label="Usuário" name="username">
          <Input size="large" disabled readOnly />
        </Form.Item>
        <Form.Item 
           label="E-mail" 
           name="email" 
           rules={[{ required: true, message: 'Por favor, insira seu e-mail!' }, { type: 'email', message: 'E-mail inválido!'}]}>
          <Input size="large" />
        </Form.Item>
        
        <Form.Item label="Discord">
          {discordUsername ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Input size="large" value={discordUsername} readOnly disabled />
              <Button icon={<FaDiscord />} onClick={handleLinkDiscord} title="Vincular outra conta Discord">
                Trocar
              </Button>
            </div>
          ) : (
            <Button icon={<FaDiscord />} type="primary" onClick={handleLinkDiscord} loading={loading}>
              Vincular com Discord
            </Button>
          )}
        </Form.Item>

        <Form.Item 
          label="Nova senha" 
          name="password"
          extra="Deixe em branco para não alterar."
          rules={[{ min: 6, message: 'A senha deve ter pelo menos 6 caracteres.' }]} >
          <Input.Password size="large" placeholder="Nova senha (mínimo 6 caracteres)" />
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button type="primary" size="large" htmlType="submit" loading={loading}>
            Salvar Alterações
          </Button>
        </Form.Item>
      </Form>
    </AppLayout>
  )
}

export default Settings
